import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`v1/api/account/permission/actions?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`v1/api/account/permission/actions/${id}`, { params });
}

export async function create(body) {
  return request(`v1/api/account/permission/actions`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`v1/api/account/permission/actions/${id}`, {
    method: 'POST',
    body,
  });
}